import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { IntegrationsMarketplaceHistoryLogsDataProviderFactory } from '../factory/IntegrationsMarketplaceHistoryLogsDataProviderFactory';
import {
  IntegrationsMarketplaceHistoryLogsBaseDataProvider
} from "../dataProvider/IntegrationsMarketplaceHistoryLogsBaseDataProvider";
import {HistoryLogEntry} from "../types";

export class IntegrationsMarketplaceHistoryLogsRepository extends BaseWebComponentRepository {
  public dataProvider: IntegrationsMarketplaceHistoryLogsBaseDataProvider;
  public dataProviderFactory: IntegrationsMarketplaceHistoryLogsDataProviderFactory;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IntegrationsMarketplaceHistoryLogsDataProviderFactory(),
    });
  }

  public clearLogs(integrationId: string) {
    return this.dataProvider.clearLogs(integrationId);
  }

  public getLogs(integrationId: string) {
    return this.dataProvider.getLogs(integrationId);
  }
}
